// PhoneButtons - reusable call/whatsapp buttons
// Usage: <PhoneButtons phone="9876543210" whatsapp="9876543210" />
import React from 'react';

export function CallBtn({ phone, style }) {
  if (!phone) return null;
  const clean = String(phone).replace(/\D/g,'');
  return (
    <a href={`tel:${clean}`} onClick={e=>e.stopPropagation()}
      style={{display:'inline-flex',alignItems:'center',justifyContent:'center',
        width:26,height:26,borderRadius:'50%',background:'#16a34a',color:'#fff',
        textDecoration:'none',flexShrink:0,...style}}
      title={`Call ${phone}`}>
      📞
    </a>
  );
}

export function WABtn({ phone, style }) {
  if (!phone) return null;
  const clean = String(phone).replace(/\D/g,'');
  const num = clean.startsWith('0') ? '91'+clean.slice(1) : clean.length===10 ? '91'+clean : clean;
  return (
    <a href={`whatsapp://send?phone=${num}`} onClick={e=>e.stopPropagation()}
      style={{display:'inline-flex',alignItems:'center',justifyContent:'center',
        width:26,height:26,borderRadius:'50%',background:'#25d366',color:'#fff',
        textDecoration:'none',flexShrink:0,...style}}
      title={`WhatsApp ${phone}`}>
      💬
    </a>
  );
}

export function PhoneField({ phone, whatsapp }) {
  if (!phone && !whatsapp) return <span style={{color:'var(--text3)'}}>—</span>;
  return (
    <div style={{display:'flex',alignItems:'center',gap:4,flexWrap:'wrap'}}>
      {phone && <span style={{fontFamily:'monospace',fontSize:12}}>{phone}</span>}
      {phone && <CallBtn phone={phone}/>}
      {whatsapp && whatsapp!==phone && <span style={{fontFamily:'monospace',fontSize:12,marginLeft:4}}>{whatsapp}</span>}
      {whatsapp && <WABtn phone={whatsapp}/>}
    </div>
  );
}
